export const API_HOST = '/api/v1/admin'
